import { render, staticRenderFns } from "./NavbarNotifications.vue?vue&type=template&id=31c2320d&scoped=true&"
import script from "./NavbarNotifications.vue?vue&type=script&lang=js&"
export * from "./NavbarNotifications.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNotifications.vue?vue&type=style&index=0&id=31c2320d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2320d",
  null
  
)

export default component.exports